import http from "../api/http";
import { get } from "lodash";

import * as actionType from "./actionType";
import { message } from "antd";
import intl from "react-intl-universal";
import map1 from "@/assets/image/map1.png";
import map2 from "@/assets/image/map2.png";
import my1 from "@/assets/image/my1.png";
import my2 from "@/assets/image/my2.png";
import y1 from "@/assets/image/y1.png";
import y2 from "@/assets/image/y2.png";
import score1 from "@/assets/image/score1.png";
import score2 from "@/assets/image/score2.png";
import hs1 from "@/assets/image/hs1.png";
import hs2 from "@/assets/image/hs2.png";
import email1 from "@/assets/image/email1.png";
import email2 from "@/assets/image/email2.png";
import help1 from "@/assets/image/help1.png";
import help2 from "@/assets/image/help2.png";

const updateInfo = (data) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...data,
      },
    });
  };
};
const getInfo = () => {
  return async (dispatch) => {
    const res = await http({
      method: "GET",
      url: "/web/merchant/auth/info",
    });

    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...res.data,
      },
    });

    sessionStorage.setItem("userInfo", JSON.stringify(res.data));
  };
};

const getUserInfo = () => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });

    const res = await http({
      method: "GET",
      url: "/web/merchant/auth/info",
    });

    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...res.data,
      },
    });
    sessionStorage.setItem("userInfo", JSON.stringify(res.data));
    dispatch({
      type: actionType.UPDATE_MENU_LIST,
      payload: {
        menuList: [
          // {
          //   path: "",
          //   component: null,
          //   code: "EMF001",
          //   children: [

          //   ],
          //   icon: null,
          //   name: intl.get("auth_package_menutitle"),
          //   id: 1,
          //   type: 3,
          //   parentId: 0,
          // },
          {
            path: "",
            component: null,
            code: "EMF346",
            children: [
              {
                path: "/find",
                component: "Find",
                code: "EMY347",
                children: null,
                selectedIcon: map2,
                unselectedIcon: map1,
                name: intl.get("auth_search_title"),
                id: 4,
                type: 1,
                parentId: 3,
              },
              {
                path: "/raidsys",
                component: "Raidsys",
                code: "EMY372",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: intl.get("auth_connection_task"),
                id: 72,
                type: 1,
                parentId: 3,
              },
            ],
            icon: null,
            name: intl.get("auth_connection_manage"),
            id: 3,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF346",
            children: [
              {
                path: "/incoming",
                component: "Incoming",
                code: "EMY348",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: intl.get("auth_my_talents"),
                id: 5,
                type: 1,
                parentId: 6,
              },
              {
                path: "/sample",
                component: "Sample",
                code: "EMY349",
                children: null,
                selectedIcon: y2,
                unselectedIcon: y1,
                name: intl.get("auth_sample_manage"),
                id: 7,
                type: 1,
                parentId: 6,
              },
              // {
              //   path: "/checklist",
              //   component: "Checklist",
              //   code: "EMY377",
              //   children: null,
              //   selectedIcon: y2,
              //   unselectedIcon: y1,
              //   name: intl.get("auth_checklist_manage"),
              //   id: 77,
              //   type: 1,
              //   parentId: 6,
              // },
              {
                path: "/group",
                component: "userGroup",
                code: "EMY377",
                children: null,
                selectedIcon: y2,
                unselectedIcon: y1,
                name: intl.get("auth_group_manage"),
                id: 78,
                type: 1,
                parentId: 6,
              },
            ],
            icon: null,
            name: intl.get("auth_cooperation"),
            id: 6,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF352",
            children: [
              {
                path: "/scriptLibrary",
                component: "ScriptLibrary",
                code: "EMY352",
                children: null,
                selectedIcon: hs2,
                unselectedIcon: hs1,
                name: intl.get("auth_script_library"),
                id: 8,
                type: 1,
                parentId: 3,
              },
              // {
              //   path: "/sendEmail",
              //   component: "SendEmail",
              //   code: "EMY356",
              //   children: null,
              //   selectedIcon: email2,
              //   unselectedIcon: email1,
              //   name: intl.get("auth_send_email"),
              //   id: 9,
              //   type: 1,
              //   parentId: 3,
              // },
              {
                path: "/score",
                component: "ScoreDeploy",
                // component: "ScoreConfig",
                // component: "Score",
                code: "EMY357",
                children: null,
                selectedIcon: score2,
                unselectedIcon: score1,
                name: intl.get("auth_talent_score_config"),
                id: 11,
                type: 1,
                parentId: 3,
              },
              {
                path: "/shopList",
                component: "ShopList",
                code: "EMY354",
                children: null,
                selectedIcon: y2,
                unselectedIcon: y1,
                name: intl.get("auth_shop_list"),
                id: 16,
                type: 1,
                parentId: 10,
              },
            ],
            icon: null,
            name: intl.get("auth_ai_assistant"),
            id: 10,
            type: 3,
            parentId: 0,
          },
          // {
          //   path: "",
          //   component: null,
          //   code: "EMF353",
          //   children: [

          //   ],
          //   icon: null,
          //   name: intl.get("auth_shop_manage"),
          //   id: 15,
          //   type: 3,
          //   parentId: 0,
          // },
          {
            path: "",
            component: null,
            code: "EMF330",
            children: [
              {
                path: "/package",
                component: "Package",
                code: "EMY348",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: intl.get("auth_package_title"),
                id: 2,
                type: 1,
                parentId: 30,
              },
              {
                path: "/order-list",
                component: "OrderList",
                code: "EMY358",
                children: null,
                selectedIcon: y2,
                unselectedIcon: y1,
                name: intl.get("auth_order_title"),
                id: 31,
                type: 1,
                parentId: 30,
              },
            ],
            icon: null,
            name: intl.get("auth_order_menutitle"),
            id: 30,
            type: 3,
            parentId: 0,
          },
          // {
          //   path: "",
          //   component: null,
          //   code: "EMF357",
          //   children: [
          //     {
          //       path: "/help",
          //       component: "Help",
          //       code: "EMY358",
          //       children: null,
          //       selectedIcon: help2,
          //       unselectedIcon: help1,
          //       name: intl.get("auth_help_center"),
          //       id: 20,
          //       type: 1,
          //       parentId: 15,
          //     },
          //   ],
          //   icon: null,
          //   name: intl.get("auth_more"),
          //   id: 20,
          //   type: 3,
          //   parentId: 0,
          // },
        ],
      },
    });

    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: false },
    });
  };
};

const getEnvCheck = () => {
  return async (dispatch) => {
    const res = await http({
      method: "POST",
      url: "/web/merchant/system/env/check",
    });
    if (res.code === 200) {
      dispatch({
        type: actionType.UPDATE_USER_INFO,
        payload: {
          ...res.data,
        },
      });
    }
  };
};

const changeLoading = (status) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status },
    });
  };
};

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

const login = (obj, errorCallback) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });
    try {
      const res = await http({
        method: "POST",
        url: "/web/merchant/auth/login",
        data: {
          ...obj,
        },
      });
      if (res.code === 200) {
        if (!get(res, "data.accessToken", "") || "") {
          message.error(intl.get("common_message_tokenError"));
          return;
        }
        let date = new Date();
        date.setTime(date.getTime() + (res?.data?.expiresIn || 3600) * 1000);

        document.cookie = `token=${
          get(res, "data.accessToken", "") || ""
        }; expires=${date.toUTCString()};`;

        if (isMobileDevice()) {
          window.location.href = "/mobileInvite";
        } else {
          if (obj.email === "tianer666@icloud.com") {
            window.location.href = "/find";
            return;
          }
          sessionStorage.setItem("firstNewModal", "1");
          window.location.href = "/envconfig";
        }
      } else {
        errorCallback && errorCallback(res);
      }
    } catch (error) {
      console.log(error);
    }
  };
};

const register = (obj) => {
  return async () => {
    const res = await http({
      method: "POST",
      url: "/web/merchant/auth/register",
      data: {
        ...obj,
      },
    });
    if (res.code === 200) {
      message.success(intl.get("common_message_registrySuccess"));
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    }
  };
};

const logout = () => {
  return async () => {
    // const res = await http({
    //   method: 'GET',
    //   url: 'logout',
    //   headers: { urlPrefix: 'login' },
    // });

    // if (res.code === 0) {
    document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    window.location.href = `/login`;
    // }
  };
};

const shopInitialize = () => {
  return async (dispatch) => {
    dispatch(
      updateInfo({
        initializeLoading: true,
      })
    );
    try {
      const res = await http({
        method: "POST",
        url: "/web/merchant/rpa-task/shop-initialize",
      });
      if (res.code === 200) {
        //
      }
    } finally {
      // dispatch(
      //   updateInfo({
      //     initializeLoading: false,
      //   })
      // );
    }
  };
};

export {
  login,
  logout,
  getInfo,
  getUserInfo,
  changeLoading,
  register,
  getEnvCheck,
  updateInfo,
  shopInitialize,
};
